import { render, staticRenderFns } from "./MarketCustomers.component.vue?vue&type=template&id=37a05155&scoped=true"
import script from "./MarketCustomers.component.vue?vue&type=script&lang=js"
export * from "./MarketCustomers.component.vue?vue&type=script&lang=js"
import style0 from "./MarketCustomers.component.vue?vue&type=style&index=0&id=37a05155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a05155",
  null
  
)

export default component.exports